import { TaxStatus } from "./types";

/**
 * Human-readable labels for each tax status
 */
export const STATUS_LABELS: Record<string, string> = {
  [TaxStatus.INFO_REQUESTED]: "Info Requested",
  [TaxStatus.INFO_RECEIVED]: "Info Received",
  [TaxStatus.IN_REVIEW]: "In Review",
  [TaxStatus.IN_PROGRESS]: "In Progress",
  [TaxStatus.WAITING_CLIENT]: "Waiting on Client",
  [TaxStatus.READY_TO_FILE]: "Ready to File",
  [TaxStatus.FILED]: "Filed",
  [TaxStatus.COMPLETED]: "Completed",
};

/**
 * Canonical order of statuses for progress tracking
 */
export const STATUS_ORDER: TaxStatus[] = [
  TaxStatus.INFO_REQUESTED,
  TaxStatus.INFO_RECEIVED,
  TaxStatus.IN_REVIEW,
  TaxStatus.IN_PROGRESS,
  TaxStatus.WAITING_CLIENT,
  TaxStatus.READY_TO_FILE,
  TaxStatus.FILED,
  TaxStatus.COMPLETED,
];

/**
 * Steps used by StatusTracker UI
 * This is what StatusTracker.tsx expects
 */
export const STATUS_STEPS = STATUS_ORDER.map((status) => ({
  key: status,
  label: STATUS_LABELS[status] ?? status,
}));
